import { BibMeasure } from './aud-bib-measure.model';
import { GeoDsMeta } from './meta-data.model';
export class BibResponse extends GeoDsMeta{
  ParentId: string;
  SeqNr: number;
  Designation: string;
  SortNr?: number;
  Measures?: BibMeasure[];
  Score: number;
  constructor(data?) {
    super();
    if (data) {
      Object.assign(this, data);
      if (data?.Measures) {
        this.Measures = [];
        data.Measures.forEach((measure) => {
          this.Measures.push(new BibMeasure(measure));
        });
      }
    }
  }
}